import { render, staticRenderFns } from "./ProductAttachment.vue?vue&type=template&id=516a59e8&"
import script from "./ProductAttachment.vue?vue&type=script&lang=js&"
export * from "./ProductAttachment.vue?vue&type=script&lang=js&"
import style0 from "./ProductAttachment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports